import React, { useState } from "react";
import axios from "axios";
import {
  Card,
  Input,
  Button,
  Row,
  Col,
  Tabs,
  Spin,
  message,
  Empty,
  Table,
  Tag,
} from "antd";
import {
  CarOutlined,
  ToolOutlined,
  FileSearchOutlined,
  DatabaseOutlined,
} from "@ant-design/icons";
import { Container, TabPane } from "reactstrap";
import Header from "components/Headers/Header";
import ProtectedRoute from "./Protected";

function HistorialVehiculo() {
  const [placa, setPlaca] = useState("");
  const [dataEquipos, setDataEquipos] = useState(null);
  const [dataRevisiones, setDataRevisiones] = useState(null);
  const [dataPorChip, setDataPorChip] = useState(null);
  const [loading, setLoading] = useState(false);

  const [idOrden, setIdOrden] = useState("");
  const [chipVehiculo, setChipVehiculo] = useState("");

  /* =========================
        CONSULTA POR PLACA
  ========================= */
  const consultar = async () => {
    if (!placa) {
      message.warning("Por favor ingrese una placa.");
      return;
    }

    setLoading(true);
    try {
      const [equiposRes, revisionesRes] = await Promise.all([
        axios.get(
          `https://inspecciongnvback-dev.azurewebsites.net/api/v1/ObtenerHistorialVehiculoEquipos/${placa}`,
        ),
        axios.get(
          `https://inspecciongnvback-dev.azurewebsites.net/api/v1/ObtenerHistorialVehiculoRevisiones/${placa}`,
        ),
      ]);

      // Equipos → ARRAY
      setDataEquipos(equiposRes.data?.[0] || null);

      // Revisiones → OBJETO
      setDataRevisiones(revisionesRes.data || null);
    } catch (error) {
      message.error("Error al consultar la información.");
      setDataEquipos(null);
      setDataRevisiones(null);
    }
    setLoading(false);
  };

  /* =========================
        CONSULTA POR CHIP
  ========================= */
  const consultarPorChip = async () => {
    if (!idOrden || !chipVehiculo) {
      message.warning("Ingrese Id Orden y Chip Vehículo.");
      return;
    }

    setLoading(true);
    try {
      const res = await axios.get(
        `https://inspecciongnvback-dev.azurewebsites.net/api/v1/ObtenerVehiculoPorChip/${idOrden}/${chipVehiculo}`,
      );
      setDataPorChip(res.data?.[0] || null);
    } catch (error) {
      message.error("Error al consultar por chip.");
      setDataPorChip(null);
    }
    setLoading(false);
  };

  /* =========================
        COLUMNAS EQUIPOS
  ========================= */
  const columnsEquipos = [
    { title: "Nombre", dataIndex: "nombreEquipo", key: "nombreEquipo" },
    { title: "Serial", dataIndex: "serial", key: "serial" },
    {
      title: "Capacidad",
      dataIndex: "capacidad",
      key: "capacidad",
      render: (v) => v || "-",
    },
    {
      title: "Fecha Fabricación",
      dataIndex: "fechaFabricacion",
      key: "fechaFabricacion",
      render: (f) => (f ? new Date(f).toLocaleDateString() : "N/A"),
    },
    {
      title: "Fecha Próx. Prueba",
      dataIndex: "prueba",
      key: "prueba",
      render: (f) => (f ? new Date(f).toLocaleDateString() : "N/A"),
    },
    {
      title: "Última Prueba",
      dataIndex: "ultimaPrueba",
      key: "ultimaPrueba",
      render: (f) => (f ? new Date(f).toLocaleDateString() : "N/A"),
    },
    {
      title: "Fecha Instalación",
      dataIndex: "fechaInstalacion",
      key: "fechaInstalacion",
      render: (f) => (f ? new Date(f).toLocaleDateString() : "N/A"),
    },
  ];

  const columnsRevisiones = [
    { title: "ID", dataIndex: "id", key: "id" },
    {
      title: "Fecha Creación",
      dataIndex: "fechaCreacion",
      key: "fechaCreacion",
      render: (f) => (f ? new Date(f).toLocaleDateString() : "N/A"),
    },
    {
      title: "Fecha Prestación",
      dataIndex: "fechaPrestacionServicio",
      key: "fechaPrestacionServicio",
      render: (f) => (f ? new Date(f).toLocaleDateString() : "N/A"),
    },
    {
      title: "Fecha Conversión",
      dataIndex: "fechaConversion",
      key: "fechaConversion",
      render: (f) => (f ? new Date(f).toLocaleDateString() : "N/A"),
    },
    { title: "Tipo Gas", dataIndex: "tipoGas", key: "tipoGas" },
    {
      title: "Tipo Orden",
      dataIndex: "nombreTipoOrdenServicio",
      key: "nombreTipoOrdenServicio",
    },
    {
      title: "Estado",
      dataIndex: "estado",
      key: "estado",
      render: (estado) => (
        <Tag color={estado === "Presentado" ? "blue" : "green"}>{estado}</Tag>
      ),
    },
    {
      title: "Chip Vehículo",
      dataIndex: "chipVehiculo",
      key: "chipVehiculo",
    },
    {
      title: "Taller",
      dataIndex: "nombreTaller",
      key: "nombreTaller",
    },
    {
      title: "Inspector",
      dataIndex: "nombreInspector",
      key: "nombreInspector",
      render: (v) => v || "N/A",
    },
    {
      title: "Próx. Revisión",
      dataIndex: "fechaProxRevision",
      key: "fechaProxRevision",
      render: (f) => (f ? new Date(f).toLocaleDateString() : "N/A"),
    },
  ];

  return (
    <ProtectedRoute>
      <Header />
      <Container className="mt--7" fluid>
        <Card title="Consulta Historial Vehículo">
          <Tabs defaultActiveKey="1">
            <TabPane
              tab={
                <span>
                  <FileSearchOutlined /> Por Placa
                </span>
              }
              key="1"
            >
              <Row gutter={12} style={{ marginBottom: 16 }}>
                <Col flex="auto">
                  <Input
                    placeholder="Ingrese la placa"
                    value={placa}
                    onChange={(e) => setPlaca(e.target.value.toUpperCase())}
                    onPressEnter={consultar}
                  />
                </Col>
                <Col>
                  <Button type="primary" onClick={consultar}>
                    Consultar
                  </Button>
                </Col>
              </Row>

              {loading && <Spin size="large" />}

              {!loading && (dataEquipos || dataRevisiones) && (
                <Tabs defaultActiveKey="1">
                  {/* EQUIPOS */}
                  <TabPane
                    tab={
                      <span>
                        <ToolOutlined /> Equipos
                      </span>
                    }
                    key="1"
                  >
                    {dataEquipos ? (
                      <Card>
                        <h3>
                          {dataEquipos.vehiculo.placa} - {dataEquipos.marca}
                        </h3>
                        <Table
                          dataSource={dataEquipos.equipos}
                          columns={columnsEquipos}
                          rowKey="id"
                          pagination={false}
                          bordered
                        />
                      </Card>
                    ) : (
                      <Empty description="No hay equipos registrados" />
                    )}
                  </TabPane>

                  {/* REVISIONES */}
                  <TabPane
                    tab={
                      <span>
                        <CarOutlined /> Revisiones
                      </span>
                    }
                    key="2"
                  >
                    {dataRevisiones ? (
                      <Card>
                        <h3>
                          {dataRevisiones.vehiculo.placa} -{" "}
                          {dataRevisiones.marca}
                        </h3>
                        <p>
                          <b>Próxima revisión:</b>{" "}
                          {new Date(
                            dataRevisiones.fechaProxRevision,
                          ).toLocaleDateString()}
                        </p>

                        <Table
                          dataSource={dataRevisiones.revisiones}
                          columns={columnsRevisiones}
                          rowKey="id"
                          pagination={false}
                          bordered
                          scroll={{ x: "max-content" }}
                        />
                      </Card>
                    ) : (
                      <Empty description="No hay revisiones registradas" />
                    )}
                  </TabPane>
                </Tabs>
              )}
            </TabPane>
            <TabPane
              tab={
                <span>
                  <DatabaseOutlined /> Por Chip
                </span>
              }
              key="2"
            >
              <Row gutter={12} style={{ marginBottom: 16 }}>
                <Col>
                  <Input
                    placeholder="Id Orden"
                    value={idOrden}
                    onChange={(e) => setIdOrden(e.target.value)}
                  />
                </Col>
                <Col>
                  <Input
                    placeholder="Chip Vehículo"
                    value={chipVehiculo}
                    onChange={(e) => setChipVehiculo(e.target.value)}
                  />
                </Col>
                <Col>
                  <Button type="primary" onClick={consultarPorChip}>
                    Consultar
                  </Button>
                </Col>
              </Row>

              {loading && <Spin />}

              {dataPorChip ? (
                <Card>
                  <h3>
                    {dataPorChip.vehiculo.placa} - {dataPorChip.marca}
                  </h3>
                  <Table
                    dataSource={dataPorChip.equipos}
                    columns={columnsEquipos}
                    rowKey="id"
                    pagination={false}
                    bordered
                  />
                </Card>
              ) : (
                <Empty description="No hay datos para esta consulta" />
              )}
            </TabPane>
          </Tabs>
        </Card>
      </Container>
    </ProtectedRoute>
  );
}

export default HistorialVehiculo;
